import { Dialog, Transition } from '@headlessui/react';
import { Fragment, useState, useEffect } from 'react';
import useAuth from '../../hooks/useAuth';
import { useEditStageMutation } from '../../redux/features/user/dealsApiSlice';
import { useGetPartnerByIdMutation } from '../../redux/features/user/partnersApiSlice';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

export default function CloseDeal({
  dealName,
  dealId,
  setReload,
  reloadValue,
}) {
  let [isOpen, setIsOpen] = useState(false);
  let [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [editStage] = useEditStageMutation();
  const [partnerData, setPartnerData] = useState([]);
  const [getByIdPartner] = useGetPartnerByIdMutation();
  const userinfo = useAuth();

  useEffect(() => {
    const getPartnerData = async () => {
      const result = await getByIdPartner({ uuid: userinfo.uuid }).unwrap();
      setPartnerData(result);
    };
    getPartnerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function closeModal() {
    setIsOpen(false);
  }

  function closeSuccessModal() {
    setIsSuccessOpen(false);
  }

  const changeStage = async (formData) => {
    try {
      await editStage({
        StageName: 'Closed Lost',
        Id: dealId,
        email: userinfo.email,
        username: userinfo.username,
        dealname: dealName,
        partner: partnerData[0].name,
        Loss_Reason__c: formData.Loss_Reason__c,
        Loss_Explanation: formData.Loss_Explanation,
      })
        .unwrap()
        .then(setIsOpen(false))
        .then(setIsSuccessOpen(true))
        .then(setReload(!reloadValue));
    } catch (error) {
      console.log(error);
    }
  };

  function openModal() {
    setIsOpen(true);
  }

  const handleSubmit = async () => {
    openModal();
  };

  const validationSchema = Yup.object({
    Loss_Explanation: Yup.string()
      .required('Explanation is required')
      .max(3000, 'Explanation must be 3000 characters or less.'),
    Loss_Reason__c: Yup.string().required('Loss reason is required'),
  });

  const initialValues = {
    Loss_Explanation: '',
    Loss_Reason__c: 'Champion left company',
  };

  return (
    <>
      <button
        onClick={() => openModal()}
        className='bg-[#FFFFFF] border border-[#FEDD0B] hover:bg-[#f1f1f1] px-3 py-1 rounded-lg text-black text-sm 2xl:text-base'
      >
        Close deal
      </button>

      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as='div' className='relative z-10' onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-75' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto '>
            <div className='flex min-h-full  items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full font-manrope max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                  {/* <Dialog.Title
                    as='h3'
                    className='text-lg font-medium leading-6 text-gray-900'
                  >
                    Change Stage1
                  </Dialog.Title> */}
                  <div className=''>
                    <p className='font-semibold text-lg'>
                      Are you sure you want to close this deal?
                    </p>
                  </div>
                  <div className='text-[#3D82F1] text-base mt-2 mb-4'>
                    Please specify the reason why this Opportunity is lost, we
                    will close this new business in our records.
                  </div>
                  <Formik
                    enableReinitialize={true}
                    validationSchema={validationSchema}
                    initialValues={initialValues}
                    onSubmit={changeStage}
                  >
                    {({ errors, touched, isValid }) => (
                      <Form>
                        {errors.Loss_Reason__c && touched.Loss_Reason__c ? (
                          <p className='text-red-500 my-2'>
                            {errors.Loss_Reason__c}
                          </p>
                        ) : (
                          <p className='my-2'>Loss reason:</p>
                        )}
                        <Field
                          className='styled-select border focus:border-[#3D82F1]  border-[#B7C6D7] rounded-md w-full  px-2 py-2 text-black placeholder-[#B7C6D7]'
                          as='select'
                          name='Loss_Reason__c'
                        >
                          <option value='Champion left company'>
                            Client left the company
                          </option>
                          <option value='Lost to Competitor'>
                            Lost to competitor
                          </option>
                          <option value='Never Contacted'>
                            Never contacted
                          </option>
                          <option value='No Budget / Lost Funding'>
                            No budget / Lost funding
                          </option>
                          <option value='No Decision / Non-Responsive'>
                            No decision / Non-Responsive
                          </option>
                          <option value='Not Compliant'>Not compliant</option>
                          <option value='Other'>Other</option>
                          <option value='Price'>Price</option>
                          <option value='Product technical limitations'>
                            Product technical limitations
                          </option>
                          <option value='Project ended'>Project ended</option>
                          <option value='Project on hold'>
                            Project on hold
                          </option>
                          <option value='Sees no value in the partnership'>
                            Sees no value in the partnership
                          </option>
                          <option value='Unhappy with the service'>
                            Unhappy with the service
                          </option>
                          <option value='Will use Wazuh without support'>
                            Will use Wazuh without support
                          </option>
                          <option value='Unpaid'>Unpaid</option>
                        </Field>
                        {errors.Loss_Explanation && touched.Loss_Explanation ? (
                          <p className='text-red-500 my-2'>
                            {errors.Loss_Explanation}
                          </p>
                        ) : (
                          <p className='my-2'>Comments:</p>
                        )}
                        <Field
                          className='border focus:border-[#3D82F1]  border-[#B7C6D7] rounded-md w-full h-36 resize-none  px-2 py-2 text-black placeholder-[#B7C6D7]'
                          as='textarea'
                          name='Loss_Explanation'
                        ></Field>
                        <div className='mt-6 justify-end flex'>
                          <button
                            type='button'
                            className='inline-flex justify-center rounded-md border border-transparent px-4 py-2 text-sm font-medium text-[#3D82F1] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2'
                            onClick={closeModal}
                          >
                            Cancel
                          </button>
                          <button
                            type='submit'
                            className='inline-flex ml-5 justify-center rounded-md border border-transparent bg-[#3D82F1] px-4 py-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2'
                          >
                            Accept!
                          </button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>

      <Transition appear show={isSuccessOpen} as={Fragment}>
        <Dialog as='div' className='relative z-10' onClose={closeSuccessModal}>
          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0'
            enterTo='opacity-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100'
            leaveTo='opacity-0'
          >
            <div className='fixed inset-0 bg-black bg-opacity-75' />
          </Transition.Child>

          <div className='fixed inset-0 overflow-y-auto '>
            <div className='flex min-h-full  items-center justify-center p-4 text-center'>
              <Transition.Child
                as={Fragment}
                enter='ease-out duration-300'
                enterFrom='opacity-0 scale-95'
                enterTo='opacity-100 scale-100'
                leave='ease-in duration-200'
                leaveFrom='opacity-100 scale-100'
                leaveTo='opacity-0 scale-95'
              >
                <Dialog.Panel className='w-full font-manrope max-w-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all'>
                  {/* <Dialog.Title
                    as='h3'
                    className='text-lg font-medium leading-6 text-gray-900'
                  >
                    Change Stage1
                  </Dialog.Title> */}
                  <div className=''>
                    <p className='font-semibold text-lg'>
                      Deal closed succesfully!
                    </p>
                  </div>

                  <div className='mt-6 justify-end flex'>
                    <button
                      type='button'
                      className='inline-flex ml-5 justify-center rounded-md border border-transparent bg-[#3D82F1] px-4 py-2 text-sm font-medium text-white hover:bg-blue-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2'
                      onClick={closeSuccessModal}
                    >
                      Accept!
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
